<app-loader [hidden]="!isLoading"></app-loader>
<div class="row" [hidden]="isLoading">
  <form *ngIf="formActive" [formGroup]="form" (ngSubmit)="submitForm()" class="form">
    <div *ngIf="departmentTargetsArray().controls?.length" formArrayName="department_targets">
      <ng-container *ngFor="let departmentTargetGroup of departmentTargetsArray().controls; let i = index">
        <div [formGroupName]="i">
          <h5>{{ departmentTargetGroup.get('department.name_' + currentLanguage)?.value }}</h5>
          <ng-container *ngIf="accomplishmentTargetsArray(i).controls?.length">
            <div formArrayName="targets" class="row">
              <ng-container
                *ngFor="let accomplishmentTarget of accomplishmentTargetsArray(i).controls; let j = index">
                <div [formGroupName]="j" class="col-12 col-lg-6">
                  <app-input type="number" [formControlName]="'goal'"
                             [label]="accomplishmentTarget.get('name_' + currentLanguage)?.value"
                             [extraLabel]="false" [fullWidth]="true">
                  </app-input>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </form>
</div>
<mat-card-actions class="d-flex flex-row-reverse">
  <button mat-raised-button type="submit" (click)="submitForm()" class="m-3 primary-button">
    {{ 'SHARED.save' | translate }}
  </button>
</mat-card-actions>
